import { pick } from 'lodash-es';

import {
  TOGGLE_QUICKVIEW,
  PUB_QUICKVIEW_REQUEST,
  PUB_QUICKVIEW_SUCCESS,
  PUB_QUICKVIEW_FAILURE,
  PUB_QUICKVIEW_SALESFORCE_UPDATE,
  CANCEL_REQUEST,
} from './action-types';
import { ASSET } from '../configs/constants';
import api, { makePubAssetList } from '../api';
import { isUnified, unifiedRefNoBy } from '../../../utils/helpers';

const { getCancelToken, cleanup } = api.buildRequestCancelation();

export const cleanupPubRequests = cleanup;

const fetchPubQuickview = () => (dispatch, getState) => {
  const { activeEntity, permissions } = getState();

  const pubParams = pick(activeEntity, ['ref_no', 'store']);
  const cancelToken = getCancelToken('pubAssetRequest').token;

  makePubAssetList(permissions).forEach((asset) => {
    dispatch({
      type: PUB_QUICKVIEW_REQUEST,
      asset,
    });
    api.fetchPubQuickview({ ...pubParams, assets: [asset] }, cancelToken)
      .then(({ data }) => {
        dispatch({
          type: PUB_QUICKVIEW_SUCCESS,
          data: {
            [activeEntity.uniqKey]: {
              [asset]: asset === ASSET.publisher
                ? { ...pubParams, ...data.publisher }
                : data[asset],
            },
          },
          asset,
        });
      })
      .catch((error) => {
        if (api.isCancel(error)) {
          dispatch({
            type: CANCEL_REQUEST,
            uniqKey: activeEntity.uniqKey,
          });
        } else {
          dispatch({
            type: PUB_QUICKVIEW_FAILURE,
            asset,
          });
        }
      });
  });
};

export const openPubQuickView = publisher => (dispatch, getState) => {
  const { activeEntity, data } = getState();

  const kind = isUnified(publisher.store) ? 'unified_publisher' : 'publisher';
  const uniqKey = unifiedRefNoBy({ ref_no: publisher.ref_no, store: publisher.store, kind });

  // Prevent opening if already open
  if (activeEntity && activeEntity.ref_no === publisher.ref_no) return;

  dispatch({
    type: TOGGLE_QUICKVIEW,
    isOpen: true,
    activeEntity: { ...publisher, kind, uniqKey },
  });

  if (!data?.[uniqKey]) {
    dispatch(fetchPubQuickview());
  }
};

export const updatePubSalesforceStatus = (uniqKey, salesforce_account_url) => ({
  type: PUB_QUICKVIEW_SALESFORCE_UPDATE,
  uniqKey,
  salesforce_account_url,
});
